export const MuiDrawer = {
    styleOverrides: {
        root: ({ theme })=>({
                '.MuiBackdrop-root': {
                    backgroundColor: theme.palette.background.overlay
                }
            }),
        paper: ({ theme })=>{
            const backgroundStyle = theme.palette.mode === 'light' ? {} : {
                backgroundImage: 'unset',
                backgroundColor: theme.palette.designSystem.grey[900]
            };
            return {
                ...backgroundStyle
            };
        }
    }
};

//# sourceMappingURL=drawer-overrides.js.map